<!-- DefaultLayout.vue -->
<template>
  <div class="all-wrapper solid-bg-all">
    <div class="layout-w">
      <MobileMenu/>

      <Menu
          :countTravelExpensesNotification="travelExpensesCount"
          :countPendingBillsForExternalCoordinator="pendingBillsCount"
          :countInquiryNotificationForCoach="inquiryCoachCount"
          :countUnreadMessagesForAccountant="unreadAccountantMessagesCount"
          :isLoaded="isLoaded"/>

      <div class="content-w position-relative">
        <TopBar
            :countTravelExpensesNotification="pendingBillsCount"
            :countPendingBillsForExternalCoordinator="pendingBillsCount"
            :countInquiryNotificationForCoach="inquiryCoachCount"
            :countUnreadMessagesForAccountant="unreadAccountantMessagesCount"
            :isLoaded="isLoaded"/>

        <router-view/>
      </div>
    </div>
  </div>
</template>
<script setup>
import coachBillingService from '@/api/CoachBilling';
import travelExpensesService from '@/api/TravelExpenses';
import privateCoachingService from '@/api/Unemployed/PrivateCoaching';
import {ErrorToast} from '@/components/VueToast';
import {computed, onBeforeUnmount, onMounted, ref} from 'vue';
import Menu from './menu/Menu.vue';
import MobileMenu from './menu/MobileMenu.vue';
import TopBar from './TopBar.vue';
import OnlineUsersService from "@/api/OnlineUsers";
import companySettingsService from "@/api/CompanySettings";
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import {piniaModalStore} from "@/store/piniaModalStore";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const piniaCompanySettings = computed(() => piniaCompanySettingsState.companySettings)

const travelExpensesCount = ref(0);
const pendingBillsCount = ref(0);
const inquiryCoachCount = ref(0);
const unreadAccountantMessagesCount = ref(0)

const companySettingsVersion = ref(0)
const isLoaded = ref(false);
let intervalId;

async function countTravelExpensesNotifications() {
  try {
    const {data} = await travelExpensesService.countNotificationForCoordinator();
    travelExpensesCount.value = data.data.count;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function countPendingBillsNotifications() {
  try {
    const {data} = await coachBillingService.coordinatorCountNotifications();
    pendingBillsCount.value = data.data.count;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function countInquiryNotificationsForCoach() {
  try {
    const {data} = await privateCoachingService.countInquiryNotificationsForCoach();
    inquiryCoachCount.value = data.data.count;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function countUnreadMessagesForAccountant() {
  try {
    const {data} = await coachBillingService.countUnreadMessagesForAccountant();
    unreadAccountantMessagesCount.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

const heartBeat = async () => {
  try {
    await OnlineUsersService.heartbeat();
  } catch (error) {
    await ErrorToast(error);
  }
}

async function checkCompanySettingsVersion() {
  try {
    const {data} = await companySettingsService.getSettings();
    const currentVersion = piniaCompanySettings.value.version;

    if (currentVersion && currentVersion !== data.data?.version) {
      const modalStore = piniaModalStore();
      modalStore.setModalData(true);
    }
  } catch (error) {
    await ErrorToast(error);
  }
}


let heartbeatIntervalId = null;
let notificationsIntervalId = null;

const fetchNotifications = async () => {
  await Promise.all([
    countTravelExpensesNotifications(),
    countPendingBillsNotifications(),
    countInquiryNotificationsForCoach(),
    countUnreadMessagesForAccountant()
  ]);
};

onMounted(async () => {
  heartbeatIntervalId = setInterval(() => {
    heartBeat();
    checkCompanySettingsVersion()
  }, 60000); // 60.000 ms = 1 min

  notificationsIntervalId = setInterval(() => {
    fetchNotifications();
  }, 180000); //  // 3 min 180000

  isLoaded.value = true;
});

onBeforeUnmount(() => {
  // Clear when component is unmounted
  clearInterval(heartbeatIntervalId);
  clearInterval(notificationsIntervalId);
});


// async function countTimeManagementMonthsForApprovalNotifications() {
//   try {
//     const { data } = await timeManagementService.countMonthsForApproval();
//
//     countTimeManagementMonthForApproval.value = data.data.count;
//   } catch (error) {
//     await ErrorToast(error);
//   }
// }

// async function countPendingHolidayRequestNotifications() {
//   try {
//     const { data } = await holidayService.countPendingRequest();
//
//     countPendingHolidayRequest.value = data.data.count;
//   } catch (error) {
//     await ErrorToast(error);
//   }
// }

// async function countPendingRequestForSickDaysNotifications() {
//   try {
//     const { data } = await reportSickDaysService.countPendingRequestV2();
//
//     countPendingRequestForSickDays.value = data.data.count;
//   } catch (error) {
//     await ErrorToast(error);
//   }
// }
</script>

